export class CustomGridTargetFieldValues {
	Field: string;
	Target: string;
	Values: Array<string>;
}
